<template>
    <div id="facilities-wrapper" class="generic-wrapper">
        <h1 class="page-title">Instalaciones</h1>
        <div id="facility-tags">
            <a href="" @click.prevent="showFacility('bar')" class="tag"
               :class="{selected: current_facility==='bar'}">Bar</a>
            <a href="" @click.prevent="showFacility('restaurant')" class="tag"
               :class="{selected: current_facility==='restaurant'}">Restaurante</a>
            <!--<a href="" class="tag">Cancha</a>-->
        </div>
        <div id="bar-wrapper" class="inner-facility-wrapper" v-if="current_facility==='bar'">
            <h2 class="page-subtitle">Bar</h2>
            <p class="body-text">Las mejores bebidas nacionales e internacionales las
                encontrara en Bar Las Hamacas, además de un extenso menú a la
                carta con platos típicos de la región además de platillos internacionales. </p>
            <p class="body-text"><strong>Horario de Atención</strong></p>
            <p class="body-text">Lunes a Viernes - 3:00pm a 11:00pm</p>
            <p class="body-text">Sábado y Domingo - 1:00pm a 10:00pm</p>
            <vue-picture-swipe :items="bar_images" class="img-gallery"></vue-picture-swipe>
        </div>
        <div id="restaurant-wrapper" class="inner-facility-wrapper"
             v-if="current_facility==='restaurant'">
            <h2 class="page-subtitle">Restaurante</h2>
            <p class="body-text">Restaurante para degustar la gastronomía de la región al
                estilo buffet ofreciendo una variedad de platillos con el verdadero
                sabor catracho, Podrá encontrar exquisitas opciones en el
                desayuno, almuerzo o cena.</p>
            <p class="body-text"><strong>Horario de Atención</strong></p>
            <p class="body-text">Lunes a Sábado - 6:30am a 9:00pm</p>
            <p class="body-text">Domingo - 7:00am a 3:00pm</p>
            <vue-picture-swipe :items="restaurant_images" class="img-gallery"></vue-picture-swipe>
        </div>
    </div>
</template>

<script>
    import VuePictureSwipe from 'vue-picture-swipe';

    export default {
        name: "Facilities",
        components: {
            VuePictureSwipe
        },
        data() {
            return {
                current_facility: 'bar',
                bar_images: [
                    {
                        src: require('../assets/images/bar/pool-view.jpg'),
                        thumbnail: require('../assets/images/bar/scaled/pool-view.jpg'),
                        w: 1920,
                        h: 1080,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/bar/20.jpg'),
                        thumbnail: require('../assets/images/bar/scaled/20.jpg'),
                        w: 1920,
                        h: 1080,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/bar/340.jpg'),
                        thumbnail: require('../assets/images/bar/scaled/340.jpg'),
                        w: 1280,
                        h: 720,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/bar/pool-side.jpg'),
                        thumbnail: require('../assets/images/bar/scaled/pool-side.jpg'),
                        w: 1920,
                        h: 1440,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/bar/pool-splash.jpg'),
                        thumbnail: require('../assets/images/bar/scaled/pool-splash.jpg'),
                        w: 1920,
                        h: 1080,
                        alt: 'Some Unsplash image'
                    },
                ],
                restaurant_images: [
                    {
                        src: require('../assets/images/restaurant/IMG-20180802-WA0007.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180802-WA0007.jpg'),
                        w: 1280,
                        h: 853,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/restaurant/IMG-20180802-WA0012.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180802-WA0012.jpg'),
                        w: 1280,
                        h: 853,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/restaurant/IMG-20180802-WA0013.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180802-WA0013.jpg'),
                        w: 1280,
                        h: 853,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/restaurant/IMG-20180803-WA0016.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180803-WA0016.jpg'),
                        w: 1280,
                        h: 853,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/restaurant/IMG-20180803-WA0017.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180803-WA0017.jpg'),
                        w: 1280,
                        h: 853,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/restaurant/IMG-20180803-WA0019.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180803-WA0019.jpg'),
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    },
                    {
                        src: require('../assets/images/restaurant/IMG-20180803-WA0021.jpg'),
                        thumbnail: require('../assets/images/restaurant/scaled/IMG-20180803-WA0021.jpg'),
                        w: 1200,
                        h: 900,
                        alt: 'Some Unsplash image'
                    },
                ]
            }
        },
        methods: {
            showFacility(facility_name) {
                this.current_facility = facility_name;
            }
        }
    }
</script>

<style scoped>
    #facility-tags {
        display: flex;
        justify-content: space-evenly;
    }

    #facility-tags .tag {
        text-decoration: none;
        padding: 10px 50px;
        font-size: 1.2rem;
        font-weight: 500;
        border-bottom: 1px solid transparent;
        color: #643229;
    }

    #facility-tags .tag:hover {
        border-bottom: 1px solid #643229;
        box-shadow: 0 10px 6px -6px #643229;
    }

    #facility-tags .tag.selected {
        border-bottom: 1px solid #643229;
        box-shadow: 0 10px 6px -6px #643229;
    }

    .inner-facility-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px;
    }

    .img-gallery {
        margin-top: 50px;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        .inner-facility-wrapper {
            padding: 0;
        }
    }

</style>